import {goToByScroll} from './go-to-by-scroll';
import {bindLinkToItem} from './bind-link-to-item';
import {videoScrub, utils, vh, whichSizeVideo, startWhichSizeVideo} from "./utils";
import {initPopups, openPopupById} from "./popups";
//import { gsap } from '../libs/gsap.min';
//import { ScrollTrigger } from '../libs/ScrollTrigger.min';

let gsapMatchmedia = gsap.matchMedia();


// Initialize a new Lenis instance for smooth scrolling
const lenis = new Lenis();

// Listen for the 'scroll' event and log the event data to the console
/*lenis.on('scroll', (e) => {
	console.log(e);
});*/

// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
lenis.on('scroll', ScrollTrigger.update);

// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
// This ensures Lenis's smooth scroll animation updates on each GSAP tick
gsap.ticker.add((time) => {
	lenis.raf(time * 1000); // Convert time from seconds to milliseconds
});

// Disable lag smoothing in GSAP to prevent any delay in scroll animations
gsap.ticker.lagSmoothing(0);


document.body.classList.add('loaded');


/**
 * Titles rows animation
 */
let animateLettersItems = document.querySelectorAll('.animate-title');

animateLettersItems.forEach(function (item) {
	let text = item.innerHTML;

	item.innerHTML = wrapWordsAndPunctuation(text);

	const innerSpans = item.querySelectorAll("span span");

	gsap.set(innerSpans, {
		y: '100%',
	});

	gsap
		.timeline({
			scrollTrigger: {
				trigger: item,
				start:   "top bottom",
				//markers: true
			}
		})
		.to(innerSpans, {
			y:        0,
			duration: 0.8,
			ease:     "power2.out",
			stagger:  0.02,
			delay:    0
		});

});


function wrapWordsAndPunctuation(text) {
	// 1) (<[^>]*>)                       -> HTML tags, keep unchanged
	// 2) ([\p{L}\p{N}]+(?:[^\p{L}\p{N}\s<]+[\p{L}\p{N}]+)*(?:[^\p{L}\p{N}\s<]+)?)
	//    -> word, allow internal punctuation that is followed by a word (e.g. d’eccellenza),
	//       and optional trailing punctuation (e.g. "word," or "word...")
	// 3) (\s+)                            -> whitespace (preserve)
	// 4) ([^\p{L}\p{N}\s<])               -> any other standalone punctuation/symbol
	const rx = /(<[^>]*>)|([\p{L}\p{N}]+(?:[^\p{L}\p{N}\s<]+[\p{L}\p{N}]+)*(?:[^\p{L}\p{N}\s<]+)?)|(\s+)|([^\p{L}\p{N}\s<])/gu;

	const out = [];
	for (const m of text.matchAll(rx)) {
		if (m[1]) {           // HTML tag
			out.push(m[1]);
		} else if (m[3]) {    // whitespace
			out.push(m[3]);
		} else {
			// m[2] is word (possibly with internal/trailing punctuation), m[4] is standalone punctuation
			out.push(`<span><span>${(m[2] || m[4])}</span></span>`);
		}
	}
	return out.join('');
}


/**
 * Sticky cards
 * @type {*[]}
 * @see https://tympanus.net/Development/StickySections/index9.html
 */

/*const contentElements      = [...document.querySelectorAll('.sticky-card')];
const totalContentElements = contentElements.length;


contentElements.forEach((el, position) => {

	const isLast    = position === totalContentElements - 1;
	const isPreLast = position === totalContentElements - 2;

	gsap.timeline({
		scrollTrigger: {
			trigger: el,
			start:   () => {
				if (isLast)
				{
					return 'top top';
				}
				else if (isPreLast)
				{
					return 'bottom top';
				}
				else
				{
					return 'bottom+=100% top';
				}
			},
			end:     '+=100%',
			scrub:   true,
			markers: true
		}
	})
		.to(el, {
			ease:     'none',
			yPercent: -100
		}, 0);

});
*/


const collezioni = gsap.utils.toArray('.page-template-template-collezioni .collezione');

collezioni.forEach((collezione) => {

	ScrollTrigger.create({
		trigger:     collezione,
		start:       () => 'top center',
		end:         () => 'bottom top',
		toggleClass: 'collezione--active',
		//markers:     true
	});

});


const collezioniSlideshow = gsap.utils.toArray('.collezioni-slideshow');

collezioniSlideshow.forEach((collezione) => {

	ScrollTrigger.create({
		trigger:     collezione,
		start:       () => 'top center',
		end:         () => 'bottom top',
		toggleClass: 'collezioni-slideshow--active',
		//markers:     true
	});

});




/**
 * ON LOAD
 */

window.addEventListener('load', function (event) {

	ScrollTrigger.getAll().forEach(t => t.refresh());

});



/**
 * ON RESIZE
 */

let prevWindowWidth = window.innerWidth;

window.addEventListener('resize', function (event) {
	if (event.target === window)
	{
		// trigger resizeEnd event only when the window resizing ends
		if (this.resizeTO)
		{
			clearTimeout(this.resizeTO);
		}
		this.resizeTO = setTimeout(function () {
			const event = new CustomEvent('resizeEnd');
			window.dispatchEvent(event);

			const windowWidth = window.innerWidth;

			if (windowWidth !== prevWindowWidth)
			{
				prevWindowWidth = windowWidth;

				const eventH = new CustomEvent('resizeHorizontallyEnd');
				window.dispatchEvent(eventH);
			}
		}, 200);
	}
});



/**
 * ON RESIZE END
 */

// do something when the window resizing ends
window.addEventListener('resizeEnd', function () {

	//ScrollTrigger.getAll().forEach(t => t.refresh());

});

window.addEventListener('resizeHorizontallyEnd', function () {

	ScrollTrigger.getAll().forEach(t => t.refresh());

});


/**
 * ON SCROLL
 */
/*window.addEventListener('scroll', function() {
});*/